import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

/**
 * Strangler-fig boundary guard (migrate-console-to-svelte): routes carrying
 * this guard belong to URL prefixes served by the Svelte bundle, so an
 * in-app navigation onto them must leave the Angular router and become a
 * document request — only the BFF decides which bundle owns a URL.
 *
 * The initial navigation is allowed through: when the BFF hands such a URL
 * to the Angular bundle, the prefix has been rolled back to Angular (a
 * routing-config-only change), and the Angular page must keep working with
 * no code change. In the rolled-back state an in-app navigation still costs
 * one document load — accepted during the overlap.
 *
 * Every migrated slice must add this guard to the Angular routes of its
 * prefixes, alongside the BFF `location` block.
 */
@Injectable()
export class StranglerGuard implements CanActivate {

  constructor(private router: Router, @Inject(DOCUMENT) private document: Document) { }

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.router.navigated) {
      return true; // AI: initial navigation — the BFF chose Angular (rollback state)
    }
    this.document.location.assign(state.url);
    return false;
  }
}
